const mergeFabrications = (customerData, fabrications_to_add) => {
  let {fabrications} = customerData
  fabrications = fabrications.concat(fabrications_to_add.map((x) => {return {name: x}}))
  customerData['fabrications'] = fabrications
  return customerData
}

export {mergeFabrications}
